import { pathOr } from 'ramda';

const AddressOverview = ({ address }) => {
  const stateAbbr = pathOr(null, ['address', 'state', 'abbr'], address);
  const countryAbbr = pathOr(null, ['address', 'country', 'abbr'], address);
  return (
    <div>
      <div>{address.businessName}</div>
      <div>{address.attention}</div>
      <div>{address.address.address1}</div>
      {address.address.address2 && <div>{address.address.address2}</div>}
      <div>
        {address.address.city}
        {stateAbbr ? ', ' + stateAbbr : ''} {address.address.postalCode}
      </div>
      {countryAbbr && <div>{countryAbbr}</div>}
    </div>
  );
};

export default AddressOverview;
